<div class="LoadingOverlay" *ngIf="isLoading" [@loadingLayout] [class._is-fixed]="isFixed">
  <pf-loading-spinner [text]="text"></pf-loading-spinner>
</div>

